import { FC, Key, ReactNode, ReactElement, cloneElement } from 'react'
import { useMobileDetector } from '../../hooks/use-mobile-detector'
import PdMedia from '../pd-media/pd-media'
import { HeadingTag } from '../../common/pd-meta-components-types'
import SemanticText from '../standard/semantic-text'

type FullScreenMediaProps = {
  title?: string[]
  desc?: Array<string | ReactNode>
  mediaUri: string
  mediaClassName?: string
  titleClassName?: string
  mediaStyle?: { [key in string]: Key }
  gradientBG?: boolean
  mask?: boolean
  titleTag?: HeadingTag
}

const FullScreenMedia: FC<FullScreenMediaProps> = ({
  title,
  mediaClassName,
  titleClassName,
  desc,
  mediaUri,
  mediaStyle,
  gradientBG,
  mask,
  titleTag,
}) => {
  const isMobileDevice = useMobileDetector()

  return (
    <div className={['w-full h-fit relative'].join(' ')}>
      <div style={{ ...mediaStyle }} className={['w-full bg-black', mediaClassName].join(' ')}>
        <PdMedia src={mediaUri} mask={mask} />
      </div>
      <div
        className={[
          'absolute top-0 left-0 w-full h-[50%] px-6 pt-15 laptop:pt-112px',
          gradientBG && 'bg-gradient-to-b from-black',
        ].join(' ')}
      >
        {/* title */}
        <div className={['mb-3', 'laptop:w-200 laptop:mb-6 laptop:mx-auto', titleClassName].join(' ')}>
          {title?.map((item, index) => (
            <SemanticText
              key={index}
              as={titleTag}
              defaultTag="h3"
              className={['text-white/90 text-24 font-semibold', 'laptop:text-center laptop:text-48'].join(' ')}
            >
              {item}
            </SemanticText>
          ))}
        </div>
        {/* desc */}
        <div className={['laptop:w-200 laptop:mx-auto'].join(' ')}>
          {desc?.map((item, index) => (
            <p key={index} className={['text-white/90 text-16', 'laptop:text-18', 'laptop:text-center'].join(' ')}>
              {item}
            </p>
          ))}
        </div>
      </div>
    </div>
  )
}

export default FullScreenMedia
